import React, { useState } from 'react'

import { SizedBox } from '@/atoms/GenericComponents/GenericComponents'
import { LanguageSelector, useLanguageSelectorTranslation } from '@/atoms/LanguageSelector'
import { useTranslation } from '@/lib/i18n/i18n'

import { Container, LanguageSwitcherButton, Menu, Title } from './LanguageSwitcher.components'
import { useLanguageSwitcher } from './LanguageSwitcher.hooks'

export const LanguageSwitcherNormal: React.FC = () => {
	const { countryLanguages, locale, onChange } = useLanguageSwitcher()
	const [open, setOpen] = useState(false)
	const { t } = useTranslation()
	const translation = useLanguageSelectorTranslation()

	const buttonRef = React.createRef<HTMLButtonElement>()
	const menuRef = React.createRef<HTMLDivElement>()

	return (
		<Container>
			<LanguageSwitcherButton ref={buttonRef} onClick={() => setOpen((open) => !open)}>
				<span>{translation.title[locale]}</span>
			</LanguageSwitcherButton>
			{open && (
				<Menu
					attachTo={{ top: true, right: true }}
					attachOffset={{ y: 50, x: -90 }}
					onClickOut={
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						(e: React.MouseEvent<any, MouseEvent>) => {
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							const isClickonMenuIcon = (node: any) => buttonRef.current?.contains(node)

							if (!isClickonMenuIcon(e.target)) {
								setOpen(false)
							}
						}
					}
				>
					<SizedBox ref={menuRef} height={menuRef.current?.offsetHeight}>
						<Title>{t('locale-selector.select-locale')}</Title>
						<LanguageSelector
							availableLanguages={countryLanguages}
							language={locale}
							onChange={(language) => {
								onChange(language)
								setOpen(false)
							}}
						/>
					</SizedBox>
				</Menu>
			)}
		</Container>
	)
}
